import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

const ManagerApprovedBanner = () => (
  <BannerWithIconContainer themeColor={ThemeColorType.success} alignItems="center">
    <Text14 themeColor={ThemeColorType.white} semiBold>
      {gettext('Timesheet approved.')}
    </Text14>
  </BannerWithIconContainer>
);

export default ManagerApprovedBanner;
